import request from "@/utils/axios";

//  获取登录信息
export function SETMEALS(data) {
    return request({
        url: '/api/setmeal/setmeals',
        method: 'POST',
        data
    })
}
//  个人中心-下单获取微信二维码
export function QRCODEURL(data) {
    return request({
        url: '/api/orderpay/qRCodeUrl',
        method: 'POST',
        data
    })
} 
// 个人中心-查询微信支付订单是否支付
export function QUERYORDER(data) {
    return request({
        url: '/api/orderpay/queryOrder',
        method: 'POST',
        data
    })
}
//官网-合作品牌
export function COOPERATEBRANDLOGOS(data) {
    return request({
        url: '/api/industrybrand/cooperateBrandLogos',
        method: 'get',
        data
    })
}
// 下单详情页
export function SETMEALSDETAIL(data) {
    return request({
        url: '/api/setmeal/setmealsDetail',
        method: 'POST',
        data
    })
}
// 套餐续费
export function SETMEALSDETAILCONTINUE(data) {
    return request({
        url: '/api/setmeal/setmealsDetailContinue',
        method: 'post',
        data
    })
}


